var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loading)?_c('Loader'):_c('div',[_c('activity-view',{attrs:{"pool":_vm.poolSlug,"activity":_vm.activitySlug}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }